import dompurify from "dompurify";
import { flushSync } from "react-dom";
import React from "react";

export default function PredictionsList({
  predictions,
  setValue,
  setPredictions,
  index,
  button,
}: {
  predictions: google.maps.places.AutocompletePrediction[];
  setValue: (val: string) => void;
  setPredictions: React.Dispatch<React.SetStateAction<google.maps.places.AutocompletePrediction[]>>;
  index: number;
  button: React.RefObject<HTMLButtonElement>;
}): React.FunctionComponentElement<{}> {
  const selectionClicked = (
    pred: string,
    setValue: (val: string) => void,
    setPredictions: React.Dispatch<React.SetStateAction<google.maps.places.AutocompletePrediction[]>>
  ) => {
    flushSync(() => {
      setValue(pred);
    });
    button.current?.click();
  };

  const formatMatch = (pred: google.maps.places.AutocompletePrediction) => {
    const desc = pred.description;
    const length = pred.matched_substrings[0].length;
    const offset = pred.matched_substrings[0].offset;
    let first = "";
    if (offset !== 0) {
      first = desc.substring(0, offset);
    }
    const start = desc.substring(offset, length + offset);
    const end = desc.substring(length + offset);
    const result = `${first}<strong>${start}</strong>${end}`;
    return {
      __html: dompurify.sanitize(result),
    };
  };

  return predictions.length > 0 ? (
    <div className="predictions_overlay">
      <div className="predictions_list">
        {predictions.map((pred, i) => (
          <div
            className={`predictions_list__item ${index === i ? "active" : ""}`}
            onClick={() => selectionClicked(pred.description, setValue, setPredictions)}
            key={pred.place_id}
            dangerouslySetInnerHTML={formatMatch(pred)}
          />
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
}
